import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';

//
// actionTypes
//
const CHANGE_LANGUAGE = 'DBM/UI/LOCALE/CHANGE_LANGUAGE';

//
// Create actions
//
const changeLanguage = createAction(CHANGE_LANGUAGE, lang => ({lang}));

export const actionTypes = {
    CHANGE_LANGUAGE
};

export const actions = {
    changeLanguage
};

//
// Export reducer
//
export const reducer = handleActions({
    [CHANGE_LANGUAGE]: (payload) =>
        (state) => {
            return state.setIn(['ui', 'locale', 'lang'], payload.lang);
        }
});

// TODO: rename locale != language other contexts
const getLocale = (state) => state.getIn(['ui', 'locale', 'lang']);

export const selectors = {
    getLocale
};
